module.exports = __webpack_public_path__ + "static/assets/c134e2adffa7d75c07dda2e2374987f5.png";